import { useEffect, useState } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { OwnIndexProtocol } from '~/modules/aerobicCapabilities/schema'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

export const Polar: React.FC = () => {
  const data = evaluationAtom.get()
  const [value, setValue] = useState<OwnIndexProtocol>({
    maxVO2Consumption: data?.ownIndex?.maxVO2Consumption ?? 0,
  })

  useEffect(() => {
    patchEvaluationAtom({ ownIndex: value })
  }, [value])

  return (
    <div className='flex gap-3'>
      <MaskedInput
        mask='float'
        inputMode='numeric'
        value={value?.maxVO2Consumption}
        label='Consumo Máximo de VO2'
        placeholder='0'
        onChange={(e) =>
          setValue((state) => ({
            ...state,
            maxVO2Consumption: e,
          }))
        }
      />
    </div>
  )
}
